import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";
import { ruta } from "../utils.js";
import loading from "../assets/project-icons/loading.svg";
const intitLeft = keyframes`
0%{
  filter:blur(10px)
}

100%{
  filter:blur(0px)
}
`;
const loadingA = keyframes`
0%{
  transform: rotate(0deg)
}

100%{
  transform: rotate(360deg)
}
`;
const ProjectsC = styled.section`

@media (max-width: 1050px) {
    .ghost {
      width: 100%;
      height: 59px;
    }
    width: 100%;
  height: 100vh;

  position: absolute;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  h1 {
    width: 80%;

    font-family: Nunito;
    font-style: normal;
    font-weight: normal;
    font-size: 27.8px;
    line-height: 23px;
    color: #fff;
  }
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 3em;
  }
  .cardProject a img {
    border-radius: 24px;
    width: 289px;
    height: 212px;
    animation: ${intitLeft} 1s;
  }
  .ghost {
    width: 100%;
    height: 59px;
  }
  .loading{
    width:100%;
    display:flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: 100vh;
    position: absolute;
    top:50%;
    img{
      animation: ${loadingA} 3s infinite;
      width:100px;
    height: 100px;
    }
    h3{
      color: #fff;
    }
  }
  }
  @media (min-width: 1000.1px) {
    width: 100%;
  height: 100vh;

  position: absolute;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  
  h1 {
    width: 80%;

    font-family: Nunito;
    font-style: normal;
    font-weight: normal;
    font-size: 27.8px;
    line-height: 23px;
    color: #fff;
  }
  .container {
    width: 90%;
    display: flex;
flex-wrap:wrap;
  
    align-items: center;
    gap: 3em;
  }
  .cardProject a img {
    border-radius: 24px;
   height:360px;
    width: 520px;
    animation: ${intitLeft} 1s;
  }
  .ghost {
    width: 100%;
    height: 59px;
  }
  .loading{
  
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
   width: 100%;
   height:90vh;
  
    overflow: hidden;
  
    img{
      animation: ${loadingA} 3s infinite;
      width:100px;
    height: 100px;
    }
    h3{
      color: #fff;
    }
  }
    .ghost {
        display:none;
      width: 100%;
      height: 59px;
    }
  }
  
`;
function Projects() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`${ruta}/Projects`)
      .then((res) => res.json())
      .then((data) => setData(data));
  }, []);
  console.log(data);
  return (
    <ProjectsC>
      <h1>My Projects</h1>
      <div className="container">
        {data? (
          data.map((e, index) => (
            <div className="cardProject" key={index}>
              <Link to={`/projects/${e.id}`} key={index}>
                <img src={`${e.thumbnail[0].formats.small.url}`} key={e.id} />
              </Link>
            </div>
          ))
        ) : ( 
          <div className="loading">
            <img src={loading} />

            <h3>This could take a few seconds</h3>
          </div>
        )}

        <div className="ghost"></div>
      </div>
    </ProjectsC>
  );
}

export default Projects;
